import './TabSearch.scss';

const TabSearch = (props) => {

}

export default TabSearch;